import { useRef, useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import butterman from "../../assets/images/Butterman.webp";
import otter from "../../assets/images/Otter.webp";
import missMango from "../../assets/images/miss_mango.png";

export const BouncingBox = ({ image }) => {
  const boxSize = 200;

  // 1) Random on‑screen start
  const [position, setPosition] = useState(() => ({
    x: Math.random() * (window.innerWidth - boxSize),
    y: Math.random() * (window.innerHeight - boxSize),
  }));

  // 2) Compute random speed & direction ONCE, then feed that object into useRef
  const initialSpeed = 2 + Math.random() * 2; // 2–4 px/frame
  const initialAngle = Math.random() * Math.PI * 2; // 0–360°
  const velocity = useRef({
    x: Math.cos(initialAngle) * initialSpeed,
    y: Math.sin(initialAngle) * initialSpeed,
  });

  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    let frameId;

    const animate = () => {
      setPosition((prev) => {
        let newX = prev.x + velocity.current.x;
        let newY = prev.y + velocity.current.y;

        // bounce off left/right
        if (newX <= 0 || newX >= window.innerWidth - boxSize) {
          velocity.current.x = -velocity.current.x;
        }
        // bounce off top/bottom
        if (newY <= 0 || newY >= window.innerHeight - boxSize) {
          velocity.current.y = -velocity.current.y;
        }
        return { x: newX, y: newY };
      });

      setRotation((r) => r + 0.5);
      frameId = requestAnimationFrame(animate);
    };

    frameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frameId);
  }, []);

  // 3) Use the image prop to determine which image to use
  let imageSrc;
  if (image === "butterman") {
    imageSrc = butterman;
  } else if (image === "missMango") {
    imageSrc = missMango;
  } else if (image === "otter") {
    imageSrc = otter;
  }

  function handleClick() {
    console.log("clicked box");
  }

  return (
    <Box
      as="img"
      src={imageSrc}
      position="fixed"
      left={`${position.x}px`}
      top={`${position.y}px`}
      height={`${boxSize}px`}
      width="auto" // ← don’t set width
      zIndex={1000}
      transform={`rotate(${rotation}deg)`}
      pointerEvents="none"
      onClick={handleClick}
    />
  );
};
